// services/customerLedger.js
import API_BASE from "../config/api";
export const fetchCustomerLedger = async (from, to) => {

  const token = localStorage.getItem("token");

  const response = await fetch(
    `${API_BASE}/Customer/Ledger?from=${from}&to=${to}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Access-Token": token,
      },
    }
  );

  if (!response.ok) {
    throw new Error("Failed to fetch customer ledger");
  }

  return await response.json();
};